module.exports = __webpack_public_path__ + "static/media/brainwavz-delta.8a7ef9c0.jpg";